// Implementation of API 579, Table 4.8: Parameters to compute the length for thickness averaging
/**
 * Computes the length factor Q based on R_t and RSF_a
 * @param rt - Remaining thickness ratio
 * @param rsfa - Acceptable remaining strength factor
 * @returns Q value for length calculation
 */
export function computeLengthFactor(rt: number, rsfa: number): number {
  if (rt < rsfa) {
    // Q = 1.123 * (((1-R_t) / (1-R_t/RSF_a))^2 - 1)^0.5
    const numerator = 1 - rt
    const denominator = 1 - rt / rsfa

    const ratio = numerator / denominator
    const innerExpression = Math.pow(ratio, 2) - 1

    // IMPORTANT NOTE from @choikh:
    // InnerExpression can only be < 0 if RSF_a > 1 which is impossible
    return 1.123 * Math.sqrt(innerExpression)
  } else {
    return 50.0
  }
}

// Implementation of API 579, Section 4.4.2, Equation 4.6
/**
 * Computes the length L based on Q, D_ml, and t_ml
 * @param q - Length factor from computeLengthFactor
 * @param dMl - Metal loss diameter
 * @param tMl - Metal loss thickness
 * @returns L value (length for thickness averaging)
 */
export function computeLength(q: number, dMl: number, tMl: number): number {
  // L = Q * sqrt(D_ml * t_ml)
  return q * Math.sqrt(dMl * tMl)
}
